import * as types from "../actions/ActionTypes";

const defaultState = {
  allCarrusels: null,
  carruselsContent: null,
  carruselsSeries: null,
  carruselWithContent: {
    community: [],
    series: [],
  },
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case "GET_CARRUSELS_LIST_FULFILLED":
      return {
        ...state,
        allCarrusels: action.payload,
      };
    case "GET_CARRUSELS_SERIES_FULFILLED":
      return {
        ...state,
        carruselsSeries: action.payload,
      };
    case "GET_CARRUSELS_CONTENT_FULFILLED":
      return {
        ...state,
        carruselsContent: action.payload,
      };
    case types.SET_CARRUSELS_WITH_CONTENT:
      let type = action.payload.type;
      return {
        ...state,
        carruselWithContent: {
          ...state.carruselWithContent,
          [type]: action.payload.cont,
        },
      };
    default:
      return state;
  }
}
